export default "__VITE_ASSET__7KNVZ4om__"